import { render, staticRenderFns } from "./ModulesPlus.vue?vue&type=template&id=fa49232a"
import script from "./ModulesPlus.vue?vue&type=script&lang=js"
export * from "./ModulesPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports